import toastr from 'toastr/toastr';

const config = {
    positionClass: "toast-bottom-right",
    timeOut: 5000
};

const Toast = {
    messages: {
        ERROR: 'Произошла ошибка',
        SUCCESS: 'Данные сохранены'
    },

    success: (message, title) => {
        return toastr.success(message, title, config);
    },

    info: (message, title) => {
        return toastr.info(message, title, config);
    },

    warning: (message, title) => {
        return toastr.warning(message, title, config);
    },

    error: (message, title) => {
        return toastr.error(message, title, config);
    },
};

export default Toast;